import CryptoJS from "crypto-js";
import { StorageConstant } from "../constants/Constants";

const ENCODE_SECRET_KEY_1 = '#&*BB&G*&#&*#G8754454^&*T*&GMAN&^#$$ISH883782&**78';
const ENCODE_SECRET_KEY_2 = '!@#$%^&*()UJCFFGS4548MAN/*+5+5as8as7d6t7ISH&^*^&^*';

const isJson = (str: any) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

const decodeData = (value: any) => {
    if (value != null && value != undefined && value != 'undefined') {
        const replaceddata: any = value?.replaceAll("Enc@de", "/");
        const decryptedData = CryptoJS.AES.decrypt(replaceddata.toString(), ENCODE_SECRET_KEY_2).toString(CryptoJS.enc.Utf8);
        const decryptedData1 = CryptoJS.AES.decrypt(decryptedData.toString(), ENCODE_SECRET_KEY_1).toString(CryptoJS.enc.Utf8);
        return decryptedData1;
    } else {
        return value;
    }
}

const getFromStorage = ({ key, type = 'local', isSecure = true }: { key: string, type?: string, isSecure?: boolean, }) => {
    let value: any = null;
    if (type === 'local') {
        value = localStorage.getItem(key)
    }
    else if (type === 'session') {
        value = sessionStorage.getItem(key)
    }

    if (isSecure) {
        value = decodeData(value);
    }
    return isJson(value) ? JSON.parse(value) : value;
};

// console.log('getFromStorage------------------>',getFromStorage({}));

export const Config = {
    url: '',
    DATE_TIME_FORMATE: 'YYYY-MM-DD[T]HH:mm:ss',
    // REACT_BASE_URL: 'http://localhost:3000/', // local
    REACT_BASE_URL: 'https://stage.quote-n-buy.com/',   //dev

    REACT_APP_SOCKET_BASE_URL:"https://stage.api.quote-n-buy.com?user_id=",  // stage socke
    REACT_APP_API_BASE_URL: 'https://stage.api.quote-n-buy.com/api',  // stage
    // REACT_APP_SOCKET_BASE_URL:"http://localhost:3046?user_id=",
    // REACT_APP_API_BASE_URL: 'http://localhost:3046/api',
    // 

    REACT_APP_SUCCESSFULLY:"https://stage.quote-n-buy.com/success/",   
    REACT_APP_CANCEL:'https://stage.quote-n-buy.com/cancel/',   

    // REACT_APP_SUCCESSFULLY:"http://localhost:3000/success/",   
    // REACT_APP_CANCEL:'http://localhost:3000/cancel/',   
    ENCODE_SECRET_KEY_1: '#&*BB&G*&#&*#G8754454^&*T*&GMAN&^#$$ISH883782&**78',
    ENCODE_SECRET_KEY_2: '!@#$%^&*()UJCFFGS4548MAN/*+5+5as8as7d6t7ISH&^*^&^*',
    FACEBOOK_SOCIAL_LOGIN_APP_ID: '641088710888267',
    FACEBOOK_SOCIAL_LOGIN_APP_SECRET: '3511c97b5116ce2cb5eac92b2d869421',
    BASE_URL: window.location.hostname === 'localhost' ? '' : '',
    GOOGLE_CLIENT_SECRET:"U2FsdGVkX1PaiVok7n+U+rtEOIC6xptS2HWNODa8AdWdhNVqQHVLOf8c054n624pA6NAiAGKa5l5EHIx8P657wUbi03EMqVskAnDY8xkZM4U7eGiR6YTCi81KkfA4SssDjthDLiG+t4PaiLnNv2AQZpPaicg==",
    GOOGLE_SOCIAL_LOGIN:"U2FsdGVkX18Dk5J71GvPaido7CTG3LUnqHrxXbFLBJiQpQSyXUsXZos3gpKkYsEGQ1omH47wxSvtLWPai862WSyzBr5NVVN0uSHjzuqcIaNl6lQ6eNF0TLti0HPaiPaiiJ6uScxY2NNdeCc6f32chk0qbvIkFZSNxVvRwVm3+od894UmWI21fM+DKqZHZbGHRIy6xg89Fyo6mqzdDvoqucMbXkJbHg==",
    GOOGLE_MAP_API_KEY: "U2FsdGVkX1Paiq30u+G7NaPRjLeyhjbsZaHQW3UYABRMOdo8yx5z515RLkTo3SlCQESfSHxE2kdWqRRyDTjTBf1ZiXyNkNP+ClxxyonRMRYefk3zF7lFYcQz+HMCuaTsy8ZnNR4EPai3rpsPjvhrzqlzNw==",
    APPLE_CLIENT_SECRET : "U2FsdGVkX1+cWnQQAjC4xINN3iNSvqyJuJtn2iqETPaiArCN2GOGgpFRExNpHPOBKQPaiuqtKZnIvnPai6vm0zQgo6QBSpWrMmcmWhvBRO2Tzw+D5pHBri7CJP4ZHAXjf2ngPai1OutjUWL0Pai6kZtFDgqGVz97obtSLryLWJrF7PxhojCQdfFttMwi9UeUyAjg1lZr7612Rd97LJi9QUbtPGnoJLLw=="

};